var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8981 9.90375L10.9538 8.58437L10.9456 8.58062C10.7928 8.51524 10.626 8.48901 10.4605 8.50428C10.2949 8.51956 10.1358 8.57587 9.99751 8.66812C9.98122 8.67888 9.96557 8.69056 9.95063 8.70312L8.42938 10C7.46563 9.53187 6.47063 8.54437 6.00251 7.59312L7.30126 6.04875C7.31376 6.03312 7.32563 6.0175 7.33688 6.00062C7.42715 5.86268 7.48192 5.70457 7.49631 5.54035C7.5107 5.37614 7.48428 5.21091 7.41938 5.05937V5.05187L6.09626 2.1025C6.01047 1.90454 5.86296 1.73963 5.67575 1.63239C5.48854 1.52516 5.27166 1.48135 5.05751 1.5075C4.21061 1.61894 3.43324 2.03485 2.87059 2.67756C2.30794 3.32026 1.99847 4.1458 2.00001 5C2.00001 9.9625 6.03751 14 11 14C11.8542 14.0015 12.6797 13.6921 13.3224 13.1294C13.9651 12.5668 14.3811 11.7894 14.4925 10.9425C14.5187 10.7284 14.475 10.5116 14.3679 10.3244C14.2607 10.1372 14.096 9.98963 13.8981 9.90375Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f9b5f6ce09333eb84a7907ede3ed1ea6.svg";
export { ForwardRef as ReactComponent };